import { Trans } from '@lingui/react/macro';
import { useMemo } from 'react';

import { type PixelType } from '@/api/pixel';
import { LinkButton } from '@/components/buttons';
import { Badge } from '@/components/typography';
import {
  PIXEL_COMPARE_MAX_LIMIT,
  PIXEL_COMPARE_MIN_LIMIT,
  PIXEL_GROUP_MAX_LIMIT,
  PIXEL_GROUP_MIN_LIMIT,
} from '@/constants/numbers';
import { ROUTES } from '@/router';

type Props = {
  selectedPixels: PixelType[];
  onRemoveSelectedPixel: (pixel: PixelType) => void;
};

const PixelTableActionContent = ({ selectedPixels, onRemoveSelectedPixel }: Props) => {
  const selectedPixelIds = useMemo(() => selectedPixels.map((pixel) => pixel.id), [selectedPixels]);

  const disableCompare =
    selectedPixels.length < PIXEL_COMPARE_MIN_LIMIT ||
    selectedPixels.length > PIXEL_COMPARE_MAX_LIMIT;
  const disableGroup =
    selectedPixels.length < PIXEL_GROUP_MIN_LIMIT || selectedPixels.length > PIXEL_GROUP_MAX_LIMIT;

  return (
    <div className="flex items-start gap-4">
      <div className="flex flex-col gap-2">
        <LinkButton disabled={disableCompare} to={ROUTES.pixelCompareByIds(selectedPixelIds)}>
          <Trans>
            Compare
            {disableCompare ? '' : ` (${selectedPixels.length})`}
          </Trans>
        </LinkButton>
        <LinkButton disabled={disableGroup} to={ROUTES.pixelGroupByIds(selectedPixelIds)}>
          <Trans>
            Group
            {disableGroup ? '' : ` (${selectedPixels.length})`}
          </Trans>
        </LinkButton>
      </div>
      <div className="flex flex-wrap gap-1">
        {selectedPixels.map((pixel) => (
          <Badge key={pixel.id} closable onClose={() => onRemoveSelectedPixel(pixel)}>
            {pixel.name}
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default PixelTableActionContent;
